import FormSection from './FormSection'
import { translations } from '../../data/translations'

const AccessibilitySection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.accessibility || translations.de.accessibility

  const handleCheckboxChange = (field, value) => {
    const currentValues = formData[field] || []
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value]
    updateFormData(field, newValues)
  }

  return (
    <FormSection
      title={t.title}
      subtitle={t.subtitle}
    >
      <div className="form-group">
        <label>{t.barrierefreiheitNiveau} <span className="required">*</span></label>
        <div className="radio-group">
          {t.barrierefreiheitOptionen.map(option => (
            <div key={option.value} className="radio-item">
              <input
                type="radio"
                id={`a11y-${option.value}`}
                name="barrierefreiheit_niveau"
                value={option.value}
                checked={formData.barrierefreiheit_niveau === option.value}
                onChange={(e) => updateFormData('barrierefreiheit_niveau', e.target.value)}
              />
              <label htmlFor={`a11y-${option.value}`}>{option.label}</label>
            </div>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label>{t.a11yFeatures}</label>
        <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
          {t.a11yFeaturesOptionen.map(option => (
            <div key={option.value} className="checkbox-item">
              <input
                type="checkbox"
                id={`a11y-feat-${option.value}`}
                checked={(formData.a11y_features || []).includes(option.value)}
                onChange={() => handleCheckboxChange('a11y_features', option.value)}
              />
              <label htmlFor={`a11y-feat-${option.value}`}>{option.label}</label>
            </div>
          ))}
        </div>
      </div>
    </FormSection>
  )
}

export default AccessibilitySection
